const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-polls', 'forum/components/Poll/PollOption');